export default __webpack_public_path__ + "static/media/prana01.241c9eeb.JPG";